// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#downloadPrompt {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 95px;
  padding: 0 16px;
  box-sizing: border-box;
  z-index: 2147483647;
}

.prompt-card {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 420px;
  margin: 0 auto;
  padding: 16px 12px;
  border-radius: 15px;
  background: #292a2e;
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.32);
  pointer-events: auto;
  animation: downloadPromptSlideDown 220ms ease-out;
  transition: transform 180ms ease, opacity 180ms ease;
  font-family: "Roboto", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #fff;
  gap: 12px;
  touch-action: pan-y;
  -webkit-user-select: none;
          user-select: none;
}
.prompt-card.prompt-card_dragging {
  transition: none;
}
.prompt-card.prompt-card_hidden {
  opacity: 0;
}
.prompt-card .icon {
  flex: 0 0 auto;
}
.prompt-card .icon img {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  object-fit: contain;
  background: #101114;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.prompt-card .info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.prompt-card .info .title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}
.prompt-card .info .domain {
  margin: 0;
  font-size: 12px;
  color: #9aa0a6;
}
.prompt-card .action {
  flex: 0 0 auto;
  margin-left: 0;
  background: transparent;
  border: none;
  color: #8ab4f8;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  padding: 4px 0;
}

@keyframes downloadPromptSlideDown {
  from {
    transform: translateY(-16px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui-components/download-app-prompt/download-app-prompt.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,oBAAA;EACA,iDAAA;EACA,oDAAA;EACA,2FAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,2CAAA;AAFJ;AAKE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAHJ;AAKI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAHN;AAMI;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAJN;AAQE;EACE,cAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AANJ;;AAUA;EACE;IACE,4BAAA;IACA,UAAA;EAPF;EAUA;IACE,wBAAA;IACA,UAAA;EARF;AACF","sourcesContent":["#downloadPrompt {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 95px;\n  padding: 0 16px;\n  box-sizing: border-box;\n  z-index: 2147483647;\n}\n\n.prompt-card {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  max-width: 420px;\n  margin: 0 auto;\n  padding: 16px 12px;\n  border-radius: 15px;\n  background: #292a2e;\n  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.32);\n  pointer-events: auto;\n  animation: downloadPromptSlideDown 220ms ease-out;\n  transition: transform 180ms ease, opacity 180ms ease;\n  font-family: 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: #fff;\n  gap: 12px;\n  touch-action: pan-y;\n  user-select: none;\n\n  &.prompt-card_dragging {\n    transition: none;\n  }\n\n  &.prompt-card_hidden {\n    opacity: 0;\n  }\n\n  .icon {\n    flex: 0 0 auto;\n  }\n\n  .icon img {\n    width: 42px;\n    height: 42px;\n    border-radius: 14px;\n    object-fit: contain;\n    background: #101114;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n  }\n\n  .info {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n\n    .title {\n      margin: 0 0 6px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #fff;\n    }\n\n    .domain {\n      margin: 0;\n      font-size: 12px;\n      color: #9aa0a6;\n    }\n  }\n\n  .action {\n    flex: 0 0 auto;\n    margin-left: 0;\n    background: transparent;\n    border: none;\n    color: #8ab4f8;\n    font-weight: 500;\n    font-size: 15px;\n    cursor: pointer;\n    padding: 4px 0;\n  }\n}\n\n@keyframes downloadPromptSlideDown {\n  from {\n    transform: translateY(-16px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
